const AnalysisTab = () => {
  return (
    <div className="bg-white rounded-lg shadow p-6">
      <h2 className="text-2xl font-semibold text-gray-900 mb-4">
        Analytics
      </h2>
      <p className="text-gray-600">
        Analytics dashboard coming soon...
      </p>
    </div>
  );
};

export default AnalysisTab;
